type Props = {
  /** 値。 */
  value: string;
};

/** タグのコンポーネント。 */
export const Tag = ({ value }: Props) => {
  return (
    <p className="inline-block border border-primary text-primary text-[12px] noto-sans-jp-regular rounded-full px-[16px] py-[4px]">
      {value}
    </p>
  );
};
